import * as React from 'react';
import { ComplexValue, CheckSymbol } from 'ui';
import styles from './checkbox-list-item.scss';

export interface CheckboxListItemOption extends ComplexValue<number> {
  title?: string;
}

export interface CheckboxListItemProps {
  name: string;
  option: CheckboxListItemOption;
  isSelected: boolean;
  onChange: (option: ComplexValue<number>, isSelected: boolean) => any;
}

export class CheckboxListItem extends React.Component<CheckboxListItemProps> {
  public onChange = () => {
    this.props.onChange && this.props.onChange(this.props.option, !this.props.isSelected);
  };

  public render() {
    const description = this.props.option.allLevelDescription || this.props.option.description;
    return (
      <div>
        <input type="checkbox"
          id={this.props.name + '_' + this.props.option.value}
          className="form-check-input visuallyhidden"
          value={this.props.option.value}
          checked={this.props.isSelected}
          onChange={this.onChange} />
        <label
          htmlFor={`${this.props.name}_${this.props.option.value}`}
          className={`${styles.label} form-check-label align-items-start`}>
          <CheckSymbol />
          {this.props.option.title && this.props.option.title}
        </label>
        {description && <div className={styles.description}>
          {description}
        </div>}
      </div>
    );
  }
}
